import script from "./CommentsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentsForm.vue?vue&type=script&setup=true&lang=js"

import "./CommentsForm.vue?vue&type=style&index=0&id=026ed904&lang=scss"

const __exports__ = script;

export default __exports__